import { render, staticRenderFns } from "./batchGiveVip.vue?vue&type=template&id=0e2b8eea&"
import script from "./batchGiveVip.vue?vue&type=script&lang=js&"
export * from "./batchGiveVip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports